import React, { useContext, useEffect, useState } from "react";
import PollMediaContent from "components/TeamPoll/PollListDetail/PollMediaContent.js";
import Progressbar from "./Progress_bar";
import Button from "components/CustomButton";
import Loader from "components/Loader";
import BackArrow from "assets/img/back.svg";
import { useHistory, useParams, useLocation } from "react-router-dom";
import PollAvatars from "./PollAvatars.js";
import pollServices from "services/pollServices";
import { useToasts } from "react-toast-notifications";
import { GlobalContext } from "store/contexts/globalContext";
import { useUserContext } from "store/contexts/userContext";
import { useTeamContext } from "store/contexts/teamContext";
import * as timelineActions from "reteamStore/actions";
import { useDispatch } from "react-redux";
import { useGlobalContext } from "store/contexts/globalContext";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import Scrollbar from "react-scrollbars-custom";

const PollListDetail = ({ pollIdd = null, pollStatus = null }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const { team } = useTeamContext();
  const { pollNotifications } = useContext(GlobalContext);
  const { user } = useUserContext();
  const { state } = useLocation();
  const { addToast } = useToasts();
  const { pollId, status } = useParams();
  const { teamId, deleteNewPost } = useTeamActionContext();
  const [check, setChecked] = useState(true);
  const [loading, setLoading] = useState(false);
  const [userResponded, setUserResponded] = useState(false);
  const [optionLoading, setOptionLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { microsoftConfigureTab, ringCentral } = useGlobalContext();
  const [optionId, setOptionId] = useState("");
  const [testData, setTestData] = useState([
    { bgcolor: "#b3dddc", completed: 60, text: "I Phone", id: 0 },
    { bgcolor: "#dddcef", completed: 30, text: "One Plus", id: 1 },
    { bgcolor: "#b3ddc7", completed: 53, text: "Nokia", id: 2 },
    { bgcolor: "#dcb3dd", completed: 60, text: "Samsung", id: 3 },
    { bgcolor: "#b3b4dd", completed: 50, text: "Techno", id: 4 },
  ]);
  const [pollDetail, setPollDetail] = useState(null);
  const LoaderStyle = {
    display: "flex",
    justifyContent: "center",
  };

  useEffect(() => {
    if (!user) {
      return;
    }

    (async () => {
      try {
        let response = null;
        // if (state?.status ?? pollStatus?.status ?? ringCentral) {
        response = await pollServices.getPollDetailAfterResponse(
          teamId,
          pollId ?? pollIdd
        );

        if (response.data.data.status !== 2) {
          var result = response.data.data.team_poll_options.some((option) =>
            option.users.some((users) => users.id === user.id)
          );
          setUserResponded(result);
        }

        setPollDetail(response?.data?.data);
        setIsLoading(false);
      } catch (e) {
        setPollDetail(null);
        setIsLoading(false);
        if (ringCentral) {
          history.push(
            `/ringCentral/teams/${teamId}/noPost/poll?type=ringcentral`
          );
          return;
        }

        history.push(`/teams/${teamId}/poll`);
      }
    })();
    //  eslint-disable-next-line
  }, [pollId, teamId, user, pollIdd, state, status]);

  useEffect(() => {
    if (check) {
      setTestData([
        { bgcolor: "#b3dddc", completed: 60, text: "I Phone", id: 0 },
        { bgcolor: "#dddcef", completed: 30, text: "One Plus", id: 1 },
        { bgcolor: "#b3ddc7", completed: 53, text: "Nokia", id: 2 },
        { bgcolor: "#dcb3dd", completed: 60, text: "Samsung", id: 3 },
        { bgcolor: "#b3b4dd", completed: 50, text: "Techno", id: 4 },
      ]);
    }
  }, [check]);

  useEffect(() => {
    if (
      pollNotifications &&
      (pollNotifications?.type === "team.poll.closed" ||
        pollNotifications?.type === "team.poll.responded") &&
      +pollNotifications?.pollId === +pollId &&
      +pollNotifications?.teamId === +teamId &&
      state?.status
    ) {
      (async () => {
        try {
          const response = await pollServices.getPollDetailAfterResponse(
            teamId,
            pollId ?? pollIdd
          );
          setPollDetail(response?.data?.data);
        } catch (e) {
          console.log(e.error, "Poll Notification Error");
        }
      })();
    }
    // eslint-disable-next-line
  }, [pollNotifications]);

  const GoBack = () => {
    history.push(`/teams/${teamId}/poll`);
  };

  const deletePoll = async () => {
    setLoading(true);
    try {
      await pollServices.deletePoll(teamId, pollId ?? pollIdd);
      dispatch(timelineActions.deletePoll(pollId ?? pollIdd));
      if (ringCentral) {
        history.push(`/ringCentral/teams/${teamId}/noPost/poll`);
        return;
      }
      deleteNewPost({ id: pollDetail.team_post_id });
      setLoading(false);
      history.push(`/teams/${teamId}/poll`);
      addToast("Poll Deleted Successfully", {
        appearance: "success",
      });
    } catch (err) {
      setLoading(false);
      addToast(err?.response?.data?.message || err?.message, {
        appearance: "error",
      });
    }
  };

  const selectOption = async (optionId) => {
    if (pollDetail?.status !== 1) {
      addToast("Poll has been closed", {
        appearance: "error",
      });
      return false;
    }
    setUserResponded(true);
    setOptionLoading(true);
    setOptionId(optionId);
    const data = {
      option_id: optionId,
    };
    try {
      const update = await pollServices.updatePollResponse(
        data,
        teamId,
        pollId ?? pollIdd
      );
      setOptionLoading(false);
      setChecked(true);
      history.replace({ ...history.location, state: { status: true } });
      addToast(update?.data?.message || "Updated Successfully", {
        appearance: "success",
      });
    } catch (e) {
      setOptionLoading(false);
      addToast(e?.response?.data?.message || e?.message, {
        appearance: "error",
      });
    }
  };

  return (
    <div className="pollBackGroundImage">
      <div className="pollDetailHeader">
        <div className="row">
          {!microsoftConfigureTab && !ringCentral && (
            <div className="col-sm-6 detailReasonBack" onClick={GoBack}>
              <img src={BackArrow} alt="Back" className="backArrow" />
            </div>
          )}
          {!microsoftConfigureTab && (
            <div className="col-sm-6">
              <h5 className="detailReasonQuestion">Poll Detail</h5>
            </div>
          )}
        </div>
      </div>
      {isLoading && (
        <h4>
          <Loader loaderStyle={LoaderStyle} />
        </h4>
      )}
      {!isLoading && (
        <>
          {pollDetail?.media_type_id !== 1 && (
            <div className="pollMediaContent">
              <PollMediaContent
                mediaCaptions={pollDetail?.media_captions?.vtt}
                media_type={pollDetail?.media_type_id || ""}
                media={pollDetail?.media || ""}
              />
            </div>
          )}

          <div className="pollReasonContent">
            <div className="row">
              <Scrollbar style={{ height:pollDetail?.content.length > 300 ? '200px': "80px", marginTop: "10px" }}>
                <div className="col-sm-12 ">
                  <h5 className="detailReasonQuestion">
                    {pollDetail?.content || ""}
                  </h5>
                </div>
              </Scrollbar>
            </div>
            <div className="progressMainDiv">
              {(pollDetail?.team_poll_options || []).map((item, index) => (
                <div className="row" key={item.id}>
                  <div className="col-sm-12">
                    <Progressbar
                      bgcolor={testData[index]?.bgcolor}
                      progress={
                        pollDetail.status === 1 && !userResponded
                          ? 0
                          : Math.floor(item.users_response_percentage || 0)
                      }
                      text={item.option}
                      id={item.id}
                      setChecked={selectOption}
                      optionLoading={optionLoading}
                      optionId={optionId}
                      loading={loading}
                    />
                  </div>
                  {check ? (
                    <div className="col-sm-12">
                      <PollAvatars
                        users={
                          !userResponded && pollDetail.status === 1
                            ? []
                            : item.users
                        }
                      />
                    </div>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
          <div className="pollReasonFooter">
            <div className="row">
              <div className="col-sm-12">
                <h5 className="pollDetailFooter">Details</h5>
              </div>
            </div>
            <div className="pollFooterDetail">
              <table className="pollFooterTr">
                <thead>
                  <tr>
                    <th>Total</th>
                    <th>Responses</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="orange">
                      {" "}
                      {pollDetail?.max_responses_count}
                    </td>
                    <td className="orange">
                      {!pollDetail?.responses_count
                        ? 0
                        : pollDetail?.responses_count || 0}
                    </td>
                    <td className={pollDetail?.status === 1 ? "green" : "red"}>
                      {pollDetail?.status === 1 ? "open" : "Closed"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {/* Only available for Admin and Super Admin */}
            {(pollDetail?.user?.id === user?.id ||
              [2, 3].includes(team?.role_id)) && (
                <div className="pollDelete">
                  <Button
                    buttonClass="btn reject-btn full_w pollDeleteButton"
                    name={
                      !loading ? "Delete Poll" : <Loader width={40} height={25} />
                    }
                    disabled={loading && true}
                    onClick={deletePoll}
                  />
                </div>
              )}
          </div>
        </>
      )}
    </div>
  );
};
export default PollListDetail;
// pollDetail?.max_responses_count -
//                           (pollDetail?.responses_count || 0)
